var map = {
	"./Alliums-Asparagus-individual-icon.png": 8866,
	"./Alliums-Garlic-individual-icon.png": 181,
	"./Alliums-Icon.png": 9078,
	"./Alliums-Onion-individual-icon.png": 1620,
	"./Alternative-Flour-Icon.png": 7545,
	"./Alternative-Flour-Individual-Icon.png": 8345,
	"./Beans-Peas-Lentils-Icon.png": 6426,
	"./Beans_Peas_Lentils-Individual-Icon.png": 7264,
	"./Beans_Peas_Lentils-Peas-individual-Icon.png": 7226,
	"./Beer-Cider-Hard-Seltzer-Beer-individual-icon.png": 2998,
	"./Beer-Cider-Hard-Seltzer-Icon.png": 3237,
	"./Berries-Blackberry-individual-icon.png": 5529,
	"./Berries-Blueberries-individual-icon-thicker-line.png": 1662,
	"./Berries-Icon.png": 5143,
	"./Berries-Strawberry-individual-icon.png": 7265,
	"./Butter-Margarine-Coconut-Oil-Icon.png": 3243,
	"./Butter-Margarine-Coconut-Oil-Individual-icon.png": 6119,
	"./Caffeinated-Beverages-Category-Icon-Option-2.png": 6138,
	"./Caffeinated-Beverages-Coffee-tea-Cup-individual-icon.png": 4143,
	"./Caffeinated-Beverages-Espresso-individual-icon.png": 6297,
	"./Caffeinated-Beverages-Icon-Option-2.png": 8701,
	"./Caffeinated-Beverages-Icon.png": 7132,
	"./Cereal-Granola-Cereal-individual-icon.png": 6643,
	"./Cereal-Granola-Granola-bar-individual-icon.png": 6259,
	"./Cereal-Granola-Granola-individual-icon.png": 9859,
	"./Cereal-Granola-Icon.png": 4178,
	"./Citrus-Fruit-Icon.png": 8454,
	"./Citrus-Fruit-Lemon-individual-icon.png": 3490,
	"./Condiments-BBQ-Sauce-individual-icon.png": 4275,
	"./Condiments-Balsamic-Vinegar-individual-icon.png": 506,
	"./Condiments-Icon.png": 1903,
	"./Condiments-Ketchup-individual-icon.png": 1138,
	"./Condiments-Mustard-individual.png": 8398,
	"./Cookin-Oils-except-olive-and-canola-category-option-1.png": 5122,
	"./Cooking-Oils-Icon.png": 9261,
	"./Cruciferous-Vegetables-Icon.png": 4070,
	"./Distilled-Liquor-Icon.png": 346,
	"./Distilled-Liquor-Mixed-Drink-individual-icon.png": 6179,
	"./Distilled-Liquor-Shots-individual-icon.png": 3228,
	"./Fried-Fast-Food-Doughnut-individual-icon.png": 8970,
	"./Fried-Fast-Food-Fries-individual-icon.png": 5471,
	"./Fried-Fast-Food-Icon-Option-2.png": 5642,
	"./Fried-Fast-Food-Icon.png": 4677,
	"./Fried-Fast-Food-Pizza-individual-icon.png": 8148,
	"./Frozen-Food-Icon.png": 9046,
	"./GF-Grains-Icon.png": 1599,
	"./GF-Grains-Rice-individual-icon.png": 1325,
	"./Hard-Cheese-Icon.png": 9822,
	"./Hard-Cheese-Individual-Icon.png": 2912,
	"./Herbal-Tea-Icon.png": 994,
	"./Jams-Jellies-Icon.png": 9479,
	"./Jams-Jellies-Individual-Icon-Option-2.png": 8724,
	"./Juice-Sports-Drinks-Coconut-Water-individual-icon.png": 4863,
	"./Juice-Sports-Drinks-Icon.png": 8923,
	"./Juice-Sports-Drinks-Sport-Drink-individual-icon.png": 9607,
	"./Leafy-Greens-Category-Icon-Option-1.png": 9780,
	"./Leafy-Greens-Icon.png": 701,
	"./Leafy-Greens-Lettuce-individual-icon.png": 2072,
	"./Leafy-Greens-Spinach-Category-or-Individual-icon.png": 1223,
	"./Leafy-Greens-or-Kale.png": 1233,
	"./Melon-Icon.png": 2484,
	"./Milk-Cream-Category-Option-1.png": 1558,
	"./Milk-Cream-Category-Option-2.png": 5325,
	"./Milk-Cream-Cream-individual-icon.png": 8842,
	"./Milk-Cream-Glass-of-Milk-individual-icon.png": 9582,
	"./Milk-Cream-Ice-Cream-individual-icon.png": 7172,
	"./Milk-Cream-Option-1.png": 6501,
	"./Milk-Cream-Option-2.png": 2494,
	"./Mushrooms-Icon-Option-1.png": 7958,
	"./Mushrooms-Icon-Option-2.png": 9197,
	"./Nightshades-Eggplant-individual-icon.png": 3612,
	"./Nightshades-Icon.png": 7655,
	"./Nightshades-Pepper-individual-icon.png": 5094,
	"./Nightshades-Tomatoes-Category-Individual-Icon.png": 6571,
	"./Nut-Butters-Icon.png": 9202,
	"./Nuts-Cashew-individual-icon.png": 6671,
	"./Olive-Canola-Oil-Icon.png": 5340,
	"./Olive-Oil-Category-Individual-Icon.png": 5012,
	"./Packaged-Snacks-Icon.png": 2591,
	"./Pitted-Fruit-Cherries-individual-icon.png": 1588,
	"./Pitted-Fruit-Icon-Option-1.png": 1676,
	"./Pitted-Fruit-Icon-Option-2.png": 407,
	"./Pitted-Fruit-Peach-individual-icon.png": 2204,
	"./Plant-Based-Milks-Icon.png": 1773,
	"./Pomes-Apple-individual-icon.png": 1584,
	"./Pomes-Icon.png": 5415,
	"./Pomes-Pear-individual-icon.png": 26,
	"./Processed-Meat-Hot-Dogs-individual-icon.png": 8481,
	"./Processed-Meat-Hot-dog-individual-icon.png": 7432,
	"./Processed-Meat-Icon.png": 3251,
	"./Processed-Meat-Sausage-(individual-icon).png": 58,
	"./Processed-Meat-Sausages-category-or-individual-icon.png": 2987,
	"./Pumpkin-Squash-Icon.png": 9909,
	"./Pumpkin_Squash-Pumpkin-individual-icon.png": 6616,
	"./Pumpkin_Squash-Squash-individual-icon.png": 2017,
	"./Pumpkin_Squash-Zucchini-individual-icon.png": 9729,
	"./Red-Meat-Bacon-individual-icon.png": 9370,
	"./Red-Meat-Icon-Option-1.png": 2384,
	"./Red-Meat-Icon-Option-2.png": 9947,
	"./Red-Meat-Steak-individual-icon.png": 785,
	"./Root-Vegetable-Celery-individual-icon.png": 1230,
	"./Root-Vegetables-Artichoke-individual-icon.png": 297,
	"./Root-Vegetables-Beet-Individual-Icon.png": 2581,
	"./Root-Vegetables-Icon.png": 9860,
	"./Seeds-Icon.png": 6845,
	"./Seeds-Tablespoon-of-seeds-individual-icon.png": 4348,
	"./Soda-Energy-Drink-Individual-Icon-Option-3.png": 8954,
	"./Soda-Energy-Drinks-Icon.png": 7315,
	"./Soda-Energy-Drinks-Individual-Icon-Option-1.png": 5097,
	"./Soda-Energy-Drinks-Individual-Icon-Option-2.png": 7880,
	"./Soft-Cheese-Cottage-Cheese-individual-icon.png": 6647,
	"./Soft-Cheese-Icon.png": 8137,
	"./Soy-Products-Category-Individual-Icon.png": 3614,
	"./Soy-Products-Icon.png": 3559,
	"./Soy-Products-Soy-Bean-individual-icon.png": 5176,
	"./Soy-Products-Tempeh-individual-icon.png": 4803,
	"./Spicy-Food-Fire-individual-icon.png": 9755,
	"./Spicy-Food-Hot-Category-Icon.png": 3497,
	"./Spicy-Food-Icon.png": 9958,
	"./Spicy-Food-Medium-Category-Icon.png": 4917,
	"./Spicy-Food-Mild-Category-Icon.png": 2618,
	"./Starchy-Vegetables-Corn-individual-icon.png": 9929,
	"./Starchy-Vegetables-Icon.png": 314,
	"./Starchy-Vegetables-Potato-individual-icon.png": 2890,
	"./Sugar-Free-Gum-Icon.png": 6094,
	"./Sugar-Free-Gum-Individual-Icon.png": 224,
	"./Sweeteners-Honey-individual-icon.png": 794,
	"./Sweeteners-Icon.png": 9210,
	"./Sweeteners-Sugar-Packet-individual-icon.png": 1612,
	"./Sweeteners-Sugar-individual-Icon.png": 8253,
	"./Sweets-Candy-individual-icon.png": 32,
	"./Sweets-Chocolate-individual-icon.png": 9741,
	"./Sweets-Icon-Option-1.png": 6212,
	"./Sweets-Icon-Option-2.png": 5119,
	"./Sweets-Pastry-individual-icon.png": 6836,
	"./Treenuts-Almonds-individual-icon.png": 3080,
	"./Treenuts-Icon.png": 7963,
	"./Treenuts-Pistachios-individual-icon.png": 9765,
	"./Wheat-Products-Bread-individual-icon.png": 6736,
	"./Wheat-Products-Flour-individual-icon.png": 8362,
	"./Wheat-Products-Icon.png": 4825,
	"./Wheat-Products-Pasta-Individual-Icon.png": 7851,
	"./Wine-Icon.png": 3082,
	"./Wine-Individual-Icon.png": 3980,
	"./dried-fruit.png": 8220,
	"./yogurt.png": 1255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6365;